import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";
import { ArtifactType } from "../../../models/SKArtifact";
import { useNavigationBar } from "../../../context/NavigationContext";

const types = [
  { imgSrc: "/icons/Text.png", type: ArtifactType.text },
  { imgSrc: "/icons/Photo.png", type: ArtifactType.photo },
  { imgSrc: "/icons/Video.png", type: ArtifactType.video },
  { imgSrc: "/icons/Audio.png", type: ArtifactType.audio },
  { imgSrc: "/icons/Link.png", type: ArtifactType.link },
  { imgSrc: "/icons/Story.png", type: ArtifactType.story },
  { imgSrc: "/icons/List.png", type: ArtifactType.list },
  { imgSrc: "/icons/Guide.png", type: ArtifactType.guide },
  { imgSrc: "/icons/Journal.png", type: ArtifactType.journal },
  { imgSrc: "/icons/Letter.png", type: ArtifactType.letter },
  { imgSrc: "/icons/Poll.png", type: ArtifactType.poll },
  { imgSrc: "/icons/Greeting.png", type: ArtifactType.greeting },
  { imgSrc: "/icons/Place.png", type: ArtifactType.place },
  { imgSrc: "/icons/Event.png", type: ArtifactType.event },
  { imgSrc: "/icons/Document.png", type: ArtifactType.document },
  // Add more items as needed
];

function ArtifactTypes() {
  const { setNavProps } = useNavigationBar();
  const { contentData, updateContentData } = useContext(CreateArtifactContext);

  const navigate = useNavigate();

  useEffect(() => {
    const navigateToArtifact = () => {
      switch (contentData.type) {
        case ArtifactType.audio:
          break;
        case ArtifactType.document:
          navigate("createDocument");
          break;
        case ArtifactType.event:
          navigate("createEvent");
          break;
        case ArtifactType.greeting:
          break;
        case ArtifactType.guide:
          break;
        case ArtifactType.journal:
          break;
        case ArtifactType.letter:
          break;
        case ArtifactType.link:
          break;
        case ArtifactType.list:
          break;
        case ArtifactType.photo:
          navigate("createStory");
          break;
        case ArtifactType.place:
          break;
        case ArtifactType.poll:
          break;
        case ArtifactType.story:
          break;
        case ArtifactType.text:
          navigate("createTextContent");
          break;
        case ArtifactType.video:
          break;
      }
    };

    setNavProps({
      backArrow: false,
      title: "Content",
      subtitle: "Channel",
      buttonTitle: "Next",
      filterOption: false,
      enableLink: contentData.type ? true : false,
      onFilter: () => {},
      onNext: () => navigateToArtifact(),
    });
  }, [setNavProps, contentData, navigate]);

  return (
    <div className="bg-white md:p-4">
      <div className="flex flex-wrap justify-center gap-2 align-middle md:justify-normal">
        {types.map((data, index) => (
          <div
            onClick={() => {
              updateContentData({ ...contentData, type: data.type });
            }}
            key={index}
            className={
              (contentData.type === data.type ? " border-black border-2 " : "  border-skgray border-[1px] ") +
              "flex flex-col first-letter w-[101px] items-center p-2 mb-4  rounded-lg"
            }
          >
            <img src={data.imgSrc} alt={data.type} className="h-[35px] w-auto" />
            <span className="mt-1 text-sm">{data.type}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ArtifactTypes;
